export default "__VITE_ASSET__f7a90198__"